<template>
  <v-row>
    <v-col
      cols="2"
        v-for="item in items"
        :key="item.position"
    >
      <v-checkbox
        :label="item.description"
        v-model="itemSelected"
        :value="item.position"
      >
      </v-checkbox>
    </v-col>
  </v-row>
</template>
<script>

  export default {
    name: 'FieldsList',
    props: {
      items: {
        type: Object,
        default() { return {}; },
      },
    },
    data() {
      return {
        itemSelected: [],
      };
    },
    methods: {
    },
    watch: {
      itemSelected: {
        deep: true,
        immediate: true,
        handler() {
          this.$emit('input', this.itemSelected);
        },
      },
    },
  };
</script>
